// Mirrors the backend permission catalogue in shared_layer/schemas/rbac.py.

export const PERMISSION_GROUPS = {
  MANAGE_PROJECTS: "MANAGE_PROJECTS",
  MANAGE_PRESALES: "MANAGE_PRESALES",
  MANAGE_SALES: "MANAGE_SALES",
  MANAGE_CHANNEL_PARTNERS: "MANAGE_CHANNEL_PARTNERS",
  CROSS_CUTTING: "CROSS_CUTTING",
};

export const PERMISSIONS = {
  PROJECT_CREATE: "project.create",
  PROJECT_EDIT: "project.edit",
  PROPERTY_EDIT: "property.edit",
  PROPERTY_DELETE: "property.delete",
  PROJECT_CHANNEL_PARTNERS_READ: "project.channel_partners.read",
  PROJECT_PROPERTIES_READ: "project.properties.read",
  LEAD_CREATE: "lead.create",
  LEAD_EDIT: "lead.edit",
  LEAD_DELETE: "lead.delete",
  SALES_AGENT_MANAGE: "sales_agent.manage",
  SALE_CREATE: "sale.create",
  SALE_READ: "sale.read",
  SALE_EDIT: "sale.edit",
  CUSTOMER_READ: "customer.read",
  CHANNEL_PARTNER_CREATE: "channel_partner.create",
  CHANNEL_PARTNER_EDIT: "channel_partner.edit",
  CHANNEL_PARTNER_DELETE: "channel_partner.delete",
  PROJECT_READ: "project.read",
  PROPERTY_READ: "property.read",
  ROLE_MANAGE: "role.manage",
};

export const PERMISSION_TO_GROUP = {
  [PERMISSIONS.PROJECT_CREATE]: PERMISSION_GROUPS.MANAGE_PROJECTS,
  [PERMISSIONS.PROJECT_EDIT]: PERMISSION_GROUPS.MANAGE_PROJECTS,
  [PERMISSIONS.PROPERTY_EDIT]: PERMISSION_GROUPS.MANAGE_PROJECTS,
  [PERMISSIONS.PROPERTY_DELETE]: PERMISSION_GROUPS.MANAGE_PROJECTS,
  [PERMISSIONS.PROJECT_CHANNEL_PARTNERS_READ]: PERMISSION_GROUPS.MANAGE_PROJECTS,
  [PERMISSIONS.PROJECT_PROPERTIES_READ]: PERMISSION_GROUPS.MANAGE_PROJECTS,
  [PERMISSIONS.LEAD_CREATE]: PERMISSION_GROUPS.MANAGE_PRESALES,
  [PERMISSIONS.LEAD_EDIT]: PERMISSION_GROUPS.MANAGE_PRESALES,
  [PERMISSIONS.LEAD_DELETE]: PERMISSION_GROUPS.MANAGE_PRESALES,
  [PERMISSIONS.SALES_AGENT_MANAGE]: PERMISSION_GROUPS.MANAGE_PRESALES,
  [PERMISSIONS.SALE_CREATE]: PERMISSION_GROUPS.MANAGE_SALES,
  [PERMISSIONS.SALE_READ]: PERMISSION_GROUPS.MANAGE_SALES,
  [PERMISSIONS.SALE_EDIT]: PERMISSION_GROUPS.MANAGE_SALES,
  [PERMISSIONS.CUSTOMER_READ]: PERMISSION_GROUPS.MANAGE_SALES,
  [PERMISSIONS.CHANNEL_PARTNER_CREATE]: PERMISSION_GROUPS.MANAGE_CHANNEL_PARTNERS,
  [PERMISSIONS.CHANNEL_PARTNER_EDIT]: PERMISSION_GROUPS.MANAGE_CHANNEL_PARTNERS,
  [PERMISSIONS.CHANNEL_PARTNER_DELETE]: PERMISSION_GROUPS.MANAGE_CHANNEL_PARTNERS,
  [PERMISSIONS.PROJECT_READ]: PERMISSION_GROUPS.CROSS_CUTTING,
  [PERMISSIONS.PROPERTY_READ]: PERMISSION_GROUPS.CROSS_CUTTING,
  [PERMISSIONS.ROLE_MANAGE]: PERMISSION_GROUPS.CROSS_CUTTING,
};

export const PERSONA = {
  STAFF: "STAFF",
  DEVELOPER_ADMIN: "DEVELOPER_ADMIN",
  CHANNEL_PARTNER: "CHANNEL_PARTNER",
  PROPERTY_BUYER: "PROPERTY_BUYER",
  INTERIOR_DESIGNER: "INTERIOR_DESIGNER",
  BV_ASSOCIATE: "BV_ASSOCIATE",
  ZUMALE_USER: "ZUMALE_USER",
};
